import * as types from "../constants/actionTypes";

export const setSelectedRoomCategory = roomCategory => ({
  type: types.UPDATE_SELECTED_ROOM_CATEGORY,
  payload: roomCategory
});

export const resetSelectedRoomCategory = () => ({
  type: types.RESET_SELECTED_ROOM_CATEGORY
});



// WEBPACK FOOTER //
// ./src/actions/selectedRoomCategoryActions.js